// Single source of truth for which paths are public marketing routes (no auth).
// Used by src/index.js (Root) to decide whether to load the lightweight public
// bundle or the heavy authenticated app. App.js keeps an identical local copy for
// its legacy in-component branch; keep the two lists in sync when adding routes.
export const PUBLIC_PATHS = [
  "/staar-practice-test",
  "/college-prep",
  "/ap-exams",
  "/challenges",
  "/30-day-science-challenge",
  "/spelling-bee",
  "/academic-competitions",
  "/free-diagnostic",
  "/unsubscribe",
  "/blog",
  "/es",
];

export function isPublicPath(pathname) {
  const explicitPublic = PUBLIC_PATHS.some((p) => pathname === p || pathname.startsWith(p + "/"));
  if (explicitPublic) return true;
  if (pathname === "/") {
    const token = localStorage.getItem("token") || localStorage.getItem("elevra_token");
    return !token;
  }
  return false;
}
